// 默认参数
const options = {
  env: 'prod', // 环境
  isRegister: true, // 是否支持注册功能
  isFindPwd: true, // 是否显示找回密码入口
  isRemember: false, // 是否支持记住账号功能
  isRegisterAccount: true, // 注册时是否需要填写账号密码
  isRegisterRole: false, // 注册时是否需要选角色
  isApiCheckRole: false, // 是否打开就检查角色接口
  isBtnStatus: true, // 登录按钮在不同阶段样式及文案动态变化
  isRealtimeCheck: true, // 是否实时校验输入框
  isQuickClear: false, // 是否支持一键清空输入的内容
  isRegisterTab: false, // 是否直接打开注册界面
  rememberKey: '3VJIA_FE_LOGIN_REMEMBER_ACCOUNTS', // 账号存储KEY
  loginCallback: (result, loginType) => { // 登录回调
    console.log(`登录类型：${loginType}；登录结果：${result.success}`);  // eslint-disable-line
  },
  registerCallback: (result) => { // 注册回调
    console.log(`注册结果：${result.success}`);  // eslint-disable-line
  },
  registerSuccessCallback: null, // 注册成功回调（有成功弹窗）
  showRolesCallback: (isShow) => { // 显示角色选择回调
    console.log('显示角色选择', isShow);  // eslint-disable-line
  },
  selectRoleCallback: (result, regResult) => { // 角色选择回调
    console.log(`注册结果：${regResult ? result.success : ''}`);  // eslint-disable-line
    console.log(`角色选择结果：${result.success}`);  // eslint-disable-line
  },
  delRememberCallback: (delFunc) => { // 删除记录前确认
    if (confirm('确认删除此账号记录？')) { // eslint-disable-line
      delFunc();
    }
  },
  closeCallback: null, // 关闭回调函数
  otherLoginCallback: null,
};

export default options;
